import { Bindable } from "bindable-data";
import { NotifyProperty } from "bindable-data";
import { nameof } from "bindable-data";
import { injectable } from "@launchtray/tsyringe-async";
import { IGameViewModel } from "./IGameViewModel";
import { Ticker } from "pixi.js";

@injectable()
export class GameViewModel extends Bindable implements IGameViewModel {
    private static readonly TIME_TO_IDLE_STATE = 7;

    public readonly isIdleState: NotifyProperty<boolean>;
    public readonly popupsShown: NotifyProperty<number>;
    public readonly mainLoginShown: NotifyProperty<boolean>;

    private seconds: number;

    public constructor() {
        super();
        this.isIdleState = new NotifyProperty<boolean>(this, nameof(this, "isIdleState"), false);
        this.popupsShown = new NotifyProperty<number>(this, nameof(this, "popupsShown"), 0);
        this.mainLoginShown = new NotifyProperty<boolean>(this, nameof(this, "mainLoginShown"), false);
        this.seconds = GameViewModel.TIME_TO_IDLE_STATE;
        this.calculateTime = this.calculateTime.bind(this);
        Ticker.shared.add(this.calculateTime);
    }

    private calculateTime(delta: number): void {
        if (this.popupsShown.value > 0 || this.isIdleState.value) {
            return;
        }
        this.seconds -= (1 / 60) * delta;
        if (this.seconds <= 0) {
            this.isIdleState.setValue(true);
        }
    }

    private reset(): void {
        this.isIdleState.setValue(false);
        this.seconds = GameViewModel.TIME_TO_IDLE_STATE;
    }

    public userActive(): void {
        this.reset();
    }

    public popupShown(): void {
        this.popupsShown.setValue(this.popupsShown.value + 1);
        this.reset();
    }

    public popupHidden(): void {
        this.popupsShown.setValue(this.popupsShown.value - 1);
    }
}
